var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{staticClass:"header-area",class:{ 'is-sticky': _vm.scrolled },attrs:{"type":"light","toggleable":"xl","fixed":"top"}},[_c('NavBarHeader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }